import { createSelector } from 'reselect'

const stateLocales = state => state.api.common.locales

export default createSelector(
  stateLocales,
  locales => locales.loading
)
